export const HEARTBEAT_EN = {
  heartbeat: 'Agent',
  heartbeatDescription: 'Monitor and manage scheduled tasks',
  createMonitor: 'Create Monitor',
  editMonitor: 'Edit Monitor',
  deleteMonitor: 'Delete Monitor',
  monitorName: 'Name',
  monitorDescription: 'Description',
  taskType: 'Task Type',
  taskQuery: 'Task Query',
  taskQueryPlainLanguageHint:
    'Emails default to German and plain language (clear summary, impact, and next steps).',
  modelSelectPlaceholder: 'Select a model',
  modelLoading: 'Loading available models...',
  modelLoadFailed: 'Model list unavailable. Monitor save is disabled until models load.',
  modelFallbackHint:
    'No selectable models found. Monitor save is disabled until a model is available.',
  heartbeatWebSearchEnabled: 'Enable Web Search',
  webSearchEnabledHint: 'When disabled, Agent runs without web grounding.',
  schedulePreset: 'Schedule Preset',
  presetDaily: 'Daily',
  presetWeekly: 'Weekly',
  presetMonthly: 'Monthly',
  dayOfMonth: 'Day of month',
  dayOfMonthHint: 'Runs on this day each month (1–28).',
  weeklyDay: 'Weekday',
  weekdayMon: 'Monday',
  weekdayTue: 'Tuesday',
  weekdayWed: 'Wednesday',
  weekdayThu: 'Thursday',
  weekdayFri: 'Friday',
  weekdaySat: 'Saturday',
  weekdaySun: 'Sunday',
  scheduleType: 'Schedule Type',
  timeOfDay: 'Time of Day',
  timezone: 'Timezone',
  outputChannel: 'Delivery Channel',
  outputTargetEmail: 'Delivery Email',
  outputTargetEmailHint: 'Agent results are sent to your account email.',
  outputTargetEmailUnavailable:
    'No account email found. Add an account email to enable monitor save.',
  outputTargetEmailInvalid: 'Please enter a valid email address.',
  enabled: 'Enabled',
  paused: 'Paused',
  active: 'Active',
  currentlyExecuting: 'Currently executing',
  lastExecution: 'Last Execution',
  nextScheduled: 'Next Scheduled',
  nextRunNow: 'Next run now',
  nextRunInMinutes: 'Next run in {count} min',
  nextRunInHours: 'Next run in {count} hour(s)',
  nextRunInDays: 'Next run in {count} day(s)',
  executeNow: 'Execute Now',
  pauseMonitor: 'Pause',
  resumeMonitor: 'Resume',
  noMonitors: 'No agents yet',
  noMonitorsDescription: 'Create an agent to start tracking scheduled tasks',
  searchMonitors: 'Search agents...',
  noMonitorsFound: 'No agents found',
  clearSearch: 'Clear search',
  confirmDeleteMessage:
    'Are you sure you want to delete this monitor? This action cannot be undone.',
  monitorCreated: 'Monitor created successfully',
  monitorUpdated: 'Monitor updated successfully',
  monitorDeleted: 'Monitor deleted successfully',
  monitorPaused: 'Monitor paused',
  monitorResumed: 'Monitor resumed',
  executionTriggered: 'Execution triggered',
  monitorCreateFailed: 'Failed to create monitor',
  monitorUpdateFailed: 'Failed to update monitor',
  monitorDeleteFailed: 'Failed to delete monitor',
  monitorPauseFailed: 'Failed to pause monitor',
  monitorResumeFailed: 'Failed to resume monitor',
  executionTriggerFailed: 'Failed to trigger execution',
  executionAlreadyRunning: 'An execution is already in progress for this monitor.',
  monitorRateLimitReached: 'Rate limit reached. Please try again later.',
  research: 'Research',
  geo: 'Geo',
  generation: 'Generation',
  cron: 'Cron',
  dailyAt: 'Daily at',
  everyNMinutes: 'Every {count} min',
  create: 'Create',
  executionHistory: 'Execution History',
  executionResult: 'Execution Result',
  noExecutions: 'No executions yet',
  noExecutionsDescription: 'This monitor has not been executed yet',
  executionRun: 'Run {count}',
  resultPreviewUnavailable: 'No inline result preview. Open the run for full output.',
  viewFullResult: 'View full result',
  executionDetails: 'Execution Details',
  executionStatus: 'Status',
  statusStart: 'Started',
  statusSent: 'Sent',
  statusStep: 'Step',
  statusRunning: 'Running',
  statusInProgress: 'In progress',
  statusPending: 'Pending',
  statusFinished: 'Finished',
  statusDone: 'Done',
  statusCompleted: 'Completed',
  statusSuccess: 'Success',
  statusSucceeded: 'Succeeded',
  statusError: 'Error',
  statusFailed: 'Failed',
  statusFailure: 'Failure',
  statusNeverRun: 'Never run',
  statusQueued: 'Queued',
  statusCancelled: 'Cancelled',
  statusTimeout: 'Timeout',
  statusSkipped: 'Skipped',
  statusDelivered: 'Delivered',
  executionTrigger: 'Trigger',
  executionStart: 'Started',
  executionEnd: 'Ended',
  resultTab: 'Result',
  addResultToEditor: 'Add to Editor',
  sourcesTab: 'Sources',
  statsTab: 'Stats',
  resultUnavailable: 'No result available for this execution.',
  sourcesUnavailable: 'No sources available for this execution.',
  resultTruncated: '[Result truncated for readability]',
  citationCount: 'Source Count',
  deliveryStatus: 'Delivery Status',
  deliveryTime: 'Delivery Time',
  deliveryError: 'Delivery Error',
  notAvailable: 'Not available',
  changeSummary: 'Change Summary',
  citations: 'Citations',
  errorMessage: 'Error',
  scheduled: 'Scheduled',
  manual: 'Manual',
  backToMonitors: 'Back to monitors',
  viewExecutions: 'View Executions',
  totalCost: 'Total Cost'
}
